import { defineComponent as _defineComponent } from 'vue'
import DeviceImage from '../devices/DeviceImage.vue';
import { Device } from '@/models/device';
import { DeviceStateData } from '@/models/deviceStateData';
import { computed, inject, ref, Ref, useSlots } from 'vue';
import { isNil } from '@/utils/misc';
import { locationsService } from '@/services/locations.service';
import { formatTimeAgo } from '@/utils/dates';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'OverviewDeviceCard',
  props: {
    device: null,
    deviceState: null,
    twoKpiGroups: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  device: Device;
  deviceState: DeviceStateData<T> | undefined;
  twoKpiGroups: boolean;
};



const now = inject<Ref<Date>>('now', () => ref(new Date()), true);
const loading = inject<Ref<boolean>>('loading', () => ref(false), true);
const isFirstLoad = inject<Ref<boolean>>('isFirstLoad', () => ref(false), true);
const compactMode = inject<Ref<boolean>>('compactMode', () => ref(false), true);

const { t } = useI18n();

function getDeviceMessage(): string {
  if (isNil(props.deviceState?.lastTimestampUtc)) {
    return '';
  }

  const lastSeenUtc = new Date(props.deviceState.lastTimestampUtc);
  return formatTimeAgo(lastSeenUtc, now.value);
}

const hasStateSlot = computed<boolean>(() => !isNil(useSlots().state?.()));

const locationName = computed<string>(
  () => locationsService.store.findById(props.device.locationId)!.name,
);

return { __sfc: true,props, now, loading, isFirstLoad, compactMode, t, getDeviceMessage, hasStateSlot, locationName, DeviceImage }
}

})